import { Component } from '@angular/core';
import { E5coreUiWorkFieldTypeCurrencyBaseComponent } from './e5core-ui-work-field-type-currency-base';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'e5core-ui-work-field-type-currency-box',
  templateUrl: './e5core-ui-work-field-type-currency-box.component.html',
  styleUrls: ['./e5core-ui-work-field-type-currency-box.component.css']
})
export class E5coreUiWorkFieldTypeCurrencyBoxComponent extends E5coreUiWorkFieldTypeCurrencyBaseComponent {
  constructor(cp: CurrencyPipe) {
    super(cp) ;
  }
}

